import { Capacitor } from '@capacitor/core';
import { useLocalStorage } from '@/composables/useLocalStorage.js';

export const RegionPlugin = {
  supportedRegionalTlds: ['cz', 'sk', 'hu'],
  currentUrlEnvObject: Capacitor.isNativePlatform()
    ? {
        cz: 'capacitor://localhost',
        sk: 'capacitor://localhost',
        hu: 'capacitor://localhost'
      }
    : {
        cz: import.meta.env.VITE_CURRENT_URL_CZ,
        sk: import.meta.env.VITE_CURRENT_URL_SK,
        hu: import.meta.env.VITE_CURRENT_URL_HU
      },
  topDomainEnvObject: {
    cz: import.meta.env.VITE_TOP_DOMAIN_CZ,
    sk: import.meta.env.VITE_TOP_DOMAIN_SK,
    hu: import.meta.env.VITE_TOP_DOMAIN_HU
  },
  getRegion: function () {
    if (Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('Preferences')) {
      const { getLS } = useLocalStorage();
      const regionFromLs = getLS('cap.region');
      if (regionFromLs) {
        return regionFromLs;
      }
    }

    const currentUrl = window.location.host;
    const domainArray = currentUrl.split('.');

    return this.supportedRegionalTlds.includes(domainArray.at(-1)) ? domainArray.at(-1) : 'cz';
  },
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$domainRegion', {
      get: () => RegionPlugin.getRegion()
    });
    Object.defineProperty(Vue.prototype, '$topDomain', {
      get: () => RegionPlugin.topDomainEnvObject[RegionPlugin.getRegion()]
    });
    Object.defineProperty(Vue.prototype, '$currentUrl', {
      get: () => RegionPlugin.currentUrlEnvObject[RegionPlugin.getRegion()]
    });
    Vue.prototype.$rootUrls = this.currentUrlEnvObject;
  }
};
